<template>
  <div class="room-info d-flex flex-column align-items-center">
    <base-header
      v-if="$device.isMobile"
      :title="$t('訪客')"
      :is-title-bold="true"
      :left-arrow="true"
      :back-on-click-left="false"
      @on-click-left="$emit('close-thirdparty-login')"
    ></base-header>
    <div
      v-if="!$device.isMobile"
      class="modal-title d-flex justify-content-between align-items-center position-relative p-3 w-100"
    >
      <span class="text-18 font-weight-bold">{{ $t('訪客') }}</span>
      <span
        class="icon-X text-32 text-primary cursor-pointer"
        @click.stop="$emit('close-thirdparty-login')"
      ></span>
    </div>
    <div class="w-100 h-100 d-flex flex-column justify-content-center">
      <div class="wrap-tab-content scroll-bar p-3 text-center">
        <div class="text-20 font-weight-bold">
          {{ $t('開始前') }}
        </div>
        <div class="text-20 font-weight-bold">
          {{ $t('我們建議您...') }}
        </div>
        <div class="my-3">
          {{ $t('點擊下方【下載截圖】按鈕') }}<br />
          {{ $t('保存您的帳號及密碼。') }}
        </div>
        <div ref="account" class="account-info w-100">
          <div>{{ $t('帳號') }}：{{ details.username }}</div>
          <div class="mb-2">{{ $t('密碼') }}：{{ details.password }}</div>
        </div>
        <div class="d-flex flex-column px-2 w-100">
          <button
            class="btn btn-secondary mb-3"
            size="md"
            @click="downloadScreenShot"
          >
            {{ $t('下載截圖') }}
          </button>
          <button
            class="btn btn-primary"
            size="md"
            @click="$emit('pass-screenshot')"
          >
            {{ $t('跳過') + $t('，') + $t('直接下一步') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseHeader from '@/components/Base/BaseHeader';
import hjjService from '@/services/hjj';
import html2canvas from 'html2canvas';
import savePhoto from '@/lib/base/savePhoto.js';

export default {
  components: {
    BaseHeader,
  },
  props: {
    details: {
      type: Object,
      default: null,
    },
  },
  methods: {
    async covert2Base64(dom) {
      const canvas = await html2canvas(dom, {backgroundColor: 'white'});
      const base64 = canvas.toDataURL();
      return base64;
    },
    async downloadScreenShot() {
      this.$store.commit('env/setIsLoading', true);
      try {
        const element = this.$refs.account;
        const base64 = await this.covert2Base64(element);
        await savePhoto(
          base64,
          `hjj-guest-account-${this.details.username}.png`
        );
        this.$store.commit('env/setIsLoading', false);
        this.$Message.success(this.$t('下載成功'), 3000);
        this.createEventRecord();
        this.$emit('pass-screenshot');
      } catch (error) {
        this.$store.commit('env/setIsLoading', false);
        this.$Message.error(this.$t('下載失敗'), 3000);
      }
    },
    createEventRecord() {
      try {
        const data = {
          eventName: 'DOWNLOAD_PASSWORD',
          username: this.details.username,
        };
        hjjService.createEventRecord(data);
      } catch (error) {
        this.$Message.error(this.$t('發生未知錯誤，再試一次'));
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>

<style lang="scss" scoped>
.room-info {
  padding: env(safe-area-inset-top) 0 env(safe-area-inset-bottom) 0;
}
.room-info {
  width: 100vw;
  height: 100vh;
  overflow: overlay;
  top: 0;
  z-index: 9999;
  position: absolute;
  background: $bgcontainer;
  @media screen and (min-width: 768px) {
    max-height: 500px;
    width: 600px;
    border-radius: 10px;
    background: white;
    position: unset;
    overflow: hidden;
    overflow: hidden;
  }
  .modal-title {
    border-bottom: 1px solid #ced4da;
  }
  .wrap-tab-content {
    height: auto;
    width: 288px;
    margin: 0 auto;

    @media screen and (min-width: 768px) {
    }
    .account-info {
      background: $grayscale-5;
      padding: 32px 0;
      border-radius: 10px;
      margin: 0 0 16px;
      font-size: 20px;
      font-weight: 700;
      line-height: 34px;
    }
  }
}
// SLIDE_TRANSITION
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-left-leave-active,
.slide-right-enter {
  transform: translate(100vw, 0);
}
.slide-left-leave-to {
  animation: none;
}
</style>
